import * as React from 'react';
import PropTypes from 'prop-types';
import { AppErrorProvider } from '@edreamsodigeo/frontend-core';
import ExtrasFunnelProvider from './Provider';
import { BrokenFlowErrorModal } from '@edreamsodigeo/frontend-additional-products';
import { BrokenFlowModalTranslationsProvider } from './BrokenFlowModalTranslationsProvider';
import { BrokenFlowModalTrackingProvider } from './BrokenFlowModalTrackingProvider';
export default function Container({
  children
}) {
  return /*#__PURE__*/React.createElement(AppErrorProvider, {
    logService: "/frontend-api"
  }, /*#__PURE__*/React.createElement(ExtrasFunnelProvider, null, children), /*#__PURE__*/React.createElement(BrokenFlowModalTranslationsProvider, null, /*#__PURE__*/React.createElement(BrokenFlowModalTrackingProvider, null, /*#__PURE__*/React.createElement(BrokenFlowErrorModal, null))));
}
Container.propTypes = {
  children: PropTypes.node.isRequired
};